import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { catchError, tap, share, expand, map, reduce, concatMap } from "rxjs/operators";
import { environment } from "@environments/environment";
import { Observable, throwError, empty } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class CommonService {
  userListObservable: Observable<any>;

  constructor(private http: HttpClient) {}

  googleUserListHref = `${environment.googleUserList}`;
  googleGroupListHref = `${environment.googleGroupList}`;
  commonSignatureHref = `${environment.commonSignature}`;
  existUserListHref = `${environment.existUserList}`;
  domainListHref = `${environment.domainList}`;
  existUserLiteListHref = `${environment.existUserLiteList}`;
  getOrgUnitListByUserHref = `${ environment.orgUnitListByUser }`;
  getAdminListByUserHref = `${ environment.adminListByOrgUnit }`;
  getUserInfoHref = `${environment.userInformation}`;
  elasticUserListHref = `${environment.elasticUserList}`;
  elasticGroupListHref = `${environment.elasticGroupList}`;
  elasticDriveListHref = `${environment.elasticDriveList}`;
  reportHref = `${environment.report}`;
  submitFeedbackHref = `${environment.submitFeedback}`;

  getGoogleUserList(pageToken): Observable<any> {
    let params;
    if (pageToken) {
      params = new HttpParams().set("pageToken", pageToken);
    } else {
      params = null;
    }
    if (this.userListObservable && !pageToken) {
      return this.userListObservable;
    } else {
      this.userListObservable = this.http
        .get<any>(this.googleUserListHref, { params })
        .pipe(
          share(),
          tap(function(data) {
            return data;
          }),
          catchError(function(err) {
            console.log(err);
            return throwError(err);
          })
        );
      return this.userListObservable;
    }
  }

  getGoogleGroupList(pageCursor) {
    let params;
    if (pageCursor) {
      params = new HttpParams().set("pageCursor", pageCursor);
    } else {
      params = null;
    }
    return this.http.get<any>(this.googleGroupListHref,{params}).pipe(
      tap(function(data) {
        return data;
      }),
      catchError(function(err) {
        console.log(err);
        return throwError(err);
      })
    );
  }

  getSignatureTemplateList() {
    return this.http.get<any>(this.commonSignatureHref).pipe(
      tap(function(data) {
        return data;
      }),
      catchError(function(err) {
        console.log(err);
        return throwError(err);
      })
    );
  }

  getUserInformation(email) {
    let params;
    if (email) {
      params = new HttpParams().set("userEmail", email);
    } else {
      params = null;
    }
    return this.http.get<any>(this.getUserInfoHref, {params}).pipe(
      tap(function(data) {
        return data;
      }),
      catchError(function(err) {
        console.log(err);
        return throwError(err);
      })
    );
  }

  getExistingUserList() {
    // return this.http.get<any>(this.existUserListHref).pipe(
    //   tap(function(data) {
    //     return data;
    //   }),
    //   catchError(function(err) {
    //     console.log(err);
    //     return throwError(err);
    //   })
    // );
    // return this.getPosts(this.existUserListHref);
    return [];
  }

  getElasticUserList(searchObject) {
    return this.http.post<any>(this.elasticUserListHref, searchObject);
  }

  getElasticUserListPromise(searchObject) {
    return this.http.post<any>(this.elasticUserListHref, searchObject).toPromise();
  }

  getElasticGroupList(searchObject) {
    return this.http.post<any>(this.elasticGroupListHref, searchObject);
  }

  getElasticDriveList(searchObject) {
    return this.http.post<any>(this.elasticDriveListHref, searchObject);
  }

  getDomain() {
    return this.http.get<any>(this.domainListHref).pipe(
      tap(function(data) {
        return data;
      }),
      catchError(function(err) {
        console.log(err);
        return throwError(err);
      })
    );
  }
  
  getExistingUserLiteList() {
    return this.getPosts(this.existUserLiteListHref);
  }
  
  
  getGroupList() {
    return this.getGroupPosts(this.googleGroupListHref);
  }
  
  getPostsChunk(api, pageCursor) {
    let params = null
    if (pageCursor) params = new HttpParams().set("pageCursor", pageCursor);
    return this.http.get<any>(api, {params}).pipe();
 }

  getPosts(api): Observable<any> {
    let pageCursor = null;
    return this.getPostsChunk(api, pageCursor).pipe(
      expand( prev => {
        if (prev.pageCursor != null) return this.getPostsChunk(api, prev.pageCursor);
        else return empty();
      }),
      map(obj => {
        return obj;
      }), 
      reduce((acc, x: any) => {
        if (acc && acc.userList) 
          acc.userList = acc.userList.concat(x.userList);
        return acc;
      })
    );
  }

  getGroupPosts(api): Observable<any> {
    let pageCursor = null;
    return this.getPostsChunk(api, pageCursor).pipe(
      expand( prev => {
        if (prev.pageCursor != null) return this.getPostsChunk(api, prev.pageCursor);
        else return empty();
      }),
      map(obj => {
        return obj;
      }), 
      reduce((acc, x: any) => {
        if (acc && acc.groupList) 
          acc.groupList = acc.groupList.concat(x.groupList);
        return acc;
      })
    );
  }

  getOrgunitsDDL () {
    return this.http.get<any>(this.getOrgUnitListByUserHref).pipe(
        tap(
            function (data) {
              return data;
            }
        ),
        catchError(
            function (err) {
                console.log(err);
                return throwError(err);
            }
        )
    );
  }

  getAdminDDL () {
    return this.http.get<any>(this.getAdminListByUserHref).pipe(
		tap(
            function (data) {
              return data;
            }
        ),
        catchError(
            function (err) {
                console.log(err);
                return throwError(err);
            }
        )
    );
  }
  
  getDashboardReport () {
    return this.http.get<any>(this.reportHref + "/dashboard-report").pipe(
        tap(
            function (data) {
              return data;
            }
        ),
        catchError(
            function (err) {
                console.log(err);
                return throwError(err);
            }
        )
    );
  }

  submitFeedback(feedback) {
    return this.http.post<any>(this.submitFeedbackHref, feedback).pipe(
      tap(
          function (data) {
            return data;
          }
      ),
      catchError(
          function (err) {
              console.log(err);
              return throwError(err);
          }
      )
    );
  }
  
}
